import {
  type PimProductV11,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { PRODUCT_TEMPLATES } from '../productTemplates'

import { productAccessorIsContraceptive } from './productAccessorIsContraceptive'
import { productAccessorIsLifestyleProduct } from './productAccessorIsLifestyleProduct'

export const productAccessorGetDefaultPrescriptionType = ({
  product,
  template,
}: {
  product: PimProductV11
  template: PRODUCT_TEMPLATES
}): PrescriptionPrescriptionTypeEnum => {
  if (template === PRODUCT_TEMPLATES.RX) {
    if (
      productAccessorIsLifestyleProduct(product) ||
      productAccessorIsContraceptive(product)
    ) {
      return PrescriptionPrescriptionTypeEnum.PrivatePrescription
    }

    return PrescriptionPrescriptionTypeEnum.InsurancePrescription
  }

  return PrescriptionPrescriptionTypeEnum.NoPrescription
}
